export default {
  TEXTBOX: 'TEXTBOX'
}
